import React, { useState, useEffect } from 'react'
import { useSelector, shallowEqual, useDispatch } from 'dva'
import { message } from 'antd'
import Input from '../Input'
import { Button } from 'components'
import styles from './index.module.less'

const allTime = 60

const selector = ({ loading }) => ({
  loading: loading.effects['login/sendSms'],
})
export default function Index({ type = 'button', mobile = {}, ...props }: any) {
  const dispatch = useDispatch()
  const { loading } = useSelector(selector, shallowEqual)
  const [codeTime, setCodeTime] = useState(allTime)
  const [clickTime, setClickTime] = useState(true)

  // 发送验证码
  const sendCode = async () => {
    if (!mobile.mobile) return message.warning('手机号码不存在，请修改后重试！')
    if (!/^1[3-9]\d{9}$/.test(mobile.mobile)) {
      message.warning('请输入正确的手机号码')
      return
    }

    if (!clickTime) return message.error('操作频繁，请稍后再试')
    setClickTime(false)
    setTimeout(() => setClickTime(true), 2000)

    let data = await dispatch({
      type: 'login/sendSms',
      payload: mobile,
    })
    data && setCodeTime(codeTime - 1)
  }

  useEffect(() => {
    if (codeTime === allTime) return
    setTimeout(() => {
      let time = codeTime
      time--
      time === 0 && (time = allTime)
      setCodeTime(time)
    }, 1000)
  }, [codeTime])

  return (
    <Input
      inputStyle={{ width: 236 }}
      placeholder="请输入验证码"
      addonAfter={
        <Button
          type="primary"
          loading={loading}
          onClick={sendCode}
          disabled={codeTime < allTime}
          className={styles.codeBut}>
          {codeTime === allTime ? '发送验证码' : `重新发送(${codeTime})`}
        </Button>
      }
      {...props}
    />
  )
}
